import { Grid, styled } from '@mui/material';

export const SectionWrapper = styled(Grid)(
  ({ theme }) => `
  flex: 1;
  border-top: 1px solid ${theme.palette.divider};
  overflow-y: auto;
  width: 100%;
`,
);
